import { createApi } from "@reduxjs/toolkit/query/react";
import { defaultBaseQuery } from "../../utils/API/fetchBaseQuery";
import { transformRequest } from "../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";

const reportTemplateAPI = createApi({
    baseQuery: defaultBaseQuery,
    reducerPath: 'reportTemplateAPI',
    endpoints: (builder) => ({

        addReportTemplate: builder.mutation({
            query: (data) => ({
                url: `/ReportTemplates/AddReportTemplate`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        updateReportTemplate: builder.mutation({
            query: (data) => ({
                url: `/ReportTemplates/UpdateReportTemplate`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getReportTemplateList: builder.mutation({
            query: (data) => ({
                url: `/ReportTemplates/GetReportTemplate`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getManageCalculationOrder: builder.query({
            query: (reportTemplateID) => ({
                url: `/ReportTemplates/GetManageCalculationOrder?ReportTemplateID=${reportTemplateID}`,
                method: `GET`,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        deleteReportTemplate: builder.mutation({
            query: (reportTemplateID) => ({
                url: `/ReportTemplates/DeleteReportTemplate?ReportTemplateID=${reportTemplateID}`,
                method: `DELETE`,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getReportTemplateById: builder.query({
            query: (reportTemplateID) => ({
                url: `/ReportTemplates/GetReportTemplateById?ReportTemplateID=${reportTemplateID}`,
                method: `GET`,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        
        getAllReportTemplateList: builder.query({
            query: () => ({
                url: `/ReportTemplates/GetAllReportTemplate`,
                method: `GET`,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAllReportTemplateByValid: builder.query({
            query: (ValId) => ({
                url: `/ReportTemplates/GetAllReportTemplateByValid?valId=${ValId}`,
                method: `GET`,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAssignedMasterFields: builder.query({
            query: (reportTemplateID) => ({
                url: `/ReportTemplates/GetAssignedMasterFields?ReportTemplateID=${reportTemplateID}`,
                method: `GET`,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getUnassignedMasterFields: builder.query({
            query: (reportTemplateID) => ({
                url: `/ReportTemplates/GetUnassignedMasterFields?ReportTemplateID=${reportTemplateID}`,
                method: `GET`,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        assignMasterField: builder.mutation({
            query: (data) => ({
                url: `/ReportTemplates/AssignMasterField`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        unassignMasterField: builder.mutation({
            query: (data) => ({
                url: `/ReportTemplates/UnassignMasterField?ReportTemplateID=${data.ReportTemplateID}&ValFieldID=${data.ValFieldID}`,
                method: `DELETE`,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        updateReportTemplateToggle: builder.mutation({
            query: (data) => ({
                url: `/ReportTemplates/UpdateReportTemplateToggle`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getReprotTemplateFieldsById: builder.query({
            query: (id) => ({
                url: `/XMLReport/GetReprotTemplateFieldsById?ReportTemplateID=${id?.ReportTemplateID}&ValFieldCategory=${id?.ValFieldCategory}&ValFieldOrigin=${id?.ValFieldOrigin}`,
                method: `GET`,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getXMLReportFieldsForMapping: builder.query({
            query: (xmlReportId) => ({
                url: `/XMLReport/GetXMLReportFieldsForMapping?XmlReportId=${xmlReportId}`,
                method: `GET`,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getUnassignedReportTemplateById: builder.query({
            query: (id) => ({
                url: `/ReportTemplates/GetUnassignedReportTemplateById?ReportTemplateId=${id}`,
                method: `GET`,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getassignedReportTemplate: builder.query({
            query: (id) => ({
                url: `/ReportTemplates/GetassignedReportTemplate?ReportTemplateId=${id}`,
                method: `GET`,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        unAssignReportTemplate: builder.mutation({
            query: (id) => ({
                url: `/ReportTemplates/UnAssignReportTemplate?ReportTemplateId=${id.ReportTemplateId}&LiabilityBasisTypeid=${id.LiabilityBasisTypeId}`,
                method: `DELETE`,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        assignReportTemplate: builder.mutation({
            query: (data) => ({
                url: `/ReportTemplates/AssignReportTemplate`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    })
});

export const { 
    useAddReportTemplateMutation, 
    useUpdateReportTemplateMutation, 
    useGetReportTemplateListMutation, 
    useDeleteReportTemplateMutation, 
    useLazyGetReportTemplateByIdQuery,
    useLazyGetAllReportTemplateListQuery,
    useLazyGetAllReportTemplateByValidQuery,
    useLazyGetAssignedMasterFieldsQuery,
    useLazyGetUnassignedMasterFieldsQuery,
    useAssignMasterFieldMutation,
    useUnassignMasterFieldMutation,
    useUpdateReportTemplateToggleMutation,
    useLazyGetReprotTemplateFieldsByIdQuery,
    useLazyGetManageCalculationOrderQuery,
    useLazyGetXMLReportFieldsForMappingQuery,
    useLazyGetUnassignedReportTemplateByIdQuery,
    useLazyGetassignedReportTemplateQuery,
    useUnAssignReportTemplateMutation,
    useAssignReportTemplateMutation
     } = reportTemplateAPI;

export default reportTemplateAPI;